(function dynamicTextDirectiveDefinition() {
    'use strict';

    angular.module('CustomControlComboKeyValue', [])
        .directive('dynamicComboKeyValue', function () {
            return {
                replace: true,
                restrict: 'E',
                templateUrl: '/app/directives/custom-control-combo-key-value/custom-control-combo-key-value-template.html',
                controller: [
                '$scope', function ($scope) {
                    if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                        $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                    }
                }]
            };
        });

    angular.module('CustomControlComboKeyValue')
       .directive('dynamicFilterComboKeyValue', ['$translate', function () {
           return {
               templateUrl: '/app/directives/custom-control-combo-key-value/custom-control-filter-combo-key-value-template.html',
               replace: true,
               restrict: 'E',
               controller: [
                   '$scope', function ($scope) {
                       if ($scope.data && !$scope.data.metadataSearchTypeFrom) {
                           $scope.data.metadataSearchTypeFrom = 'Equal';
                       }

                       if ($scope.data && $scope.data.metadataOptions && (typeof $scope.data.metadataOptions === 'string')) {
                           $scope.data.metadataOptions = $.parseJSON($scope.data.metadataOptions);
                       }

                   }
               ],
               link: function (scope, iElement, iAttrs, formCtrl) {
                       scope.filterNullValue = iAttrs.filternullvalue;
                   }
           };
       }]);
})();